fragment TestimonialFragment on testimonial_Entry {
  typeHandle

  heading

  testimonialLayout
  backgroundBlack

  useShopifyData
  testimonials {
    ... on singleTestimonial_Entry {
      id
      body
      authorName
      authorImage {
        url
        title
      }
    }
  }
}
